<template>
  <PlainAddress
    :input-data="computedInputData"
    :value="storedAddressText"
    :form-name="formName"
    :gtm-form-name="gtmFormName"
    @input="onInput"
    @address-structured="onAddressStructured"
  />
</template>

<script>
import formGtm from '@/mixins/formGtm';
import PlainAddress from '@/components/newForms/PlainAddress.vue';

export default {
  name: 'AddressGoogle',
  components: { PlainAddress },
  mixins: [formGtm],
  props: {
    messages: { type: String, default: null },
    title: { type: String, default: null },
    placeholder: { type: String, default: null },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    storedAddressText() {
      return this.$store.state.forms.addressGoogle.addressText || '';
    },
    storedAddressGoogle() {
      return this.$store.state.forms.addressGoogle.addressGoogle || {};
    },
    computedInputData() {
      const stored = this.storedAddressGoogle;
      // Předáváme jen fieldy s hodnotou — prázdné stringy by přepsaly výsledky
      // z parseLooseAddress a po refreshi by se nevyplnila pole PSČ a Stát
      const meta = {};
      const formatted = stored.formattedAddress || this.storedAddressText || '';
      if (formatted) {
        meta.formatted = formatted;
      }
      if (stored.country) {
        meta.country = stored.country;
      }
      if (stored.postcode) {
        meta.zip = stored.postcode;
      }
      if (stored.street) {
        meta.streetName = stored.street;
      }
      if (stored.placeId) {
        meta.placeId = stored.placeId;
      }
      return {
        id: 'addressGoogle',
        name: 'addressGoogle',
        type: 'address',
        required: false,
        label: this.title || this.$t('preventionForm.address.title'),
        help: this.messages || '',
        meta
      };
    }
  },
  methods: {
    onInput(value) {
      this.$store.commit('forms/addressGoogle/updateAddressText', value);
    },
    onAddressStructured(meta) {
      this.$store.commit('forms/addressGoogle/updateAddressGoogle', {
        formattedAddress: meta.formatted || '',
        country: meta.country || '',
        postcode: meta.zip || '',
        street:
          meta.streetLine || [meta.streetName, meta.streetNumber].filter(Boolean).join(' ').trim(),
        placeId: meta.placeId || null
      });
    }
  }
};
</script>
